/*
  SOMNÉ: samtyckesrutans text på svenska.
  Rutan är butikens inbyggda banner; dess text kommer från plattformens eget skript och går inte att
  ändra i Liquid. Skriptet väntar in rutan och skriver om rubrik, stycke och knappar. Orden står som
  data-attribut på skripttaggen (snippets/somne-kakruta.liquid). Länken till integritetspolicyn
  behålls och flyttas till %link% i meningen. Kodförlaga: Noelvas noelva-samtykke.js.
*/
(function () {
  var tag = document.querySelector('script[data-sk-body]');
  if (!tag) return;

  var TITTEL = tag.getAttribute('data-sk-title') || '';
  var TEKST = tag.getAttribute('data-sk-body') || '';
  var AVSLA = tag.getAttribute('data-sk-decline') || '';
  var GODTA = tag.getAttribute('data-sk-accept') || '';
  var INNSTILLINGER = tag.getAttribute('data-sk-prefs') || '';

  function skrivOm(banner) {
    var stykke = banner.querySelector('p');
    if (!stykke || stykke.dataset.skOmskrevet) return false;

    /* Länken finns redan i stycket och ska stå kvar — bara flyttas till sin
       plats i vår mening. Platsen märks ut med %link% i språkfilen, så hela
       den synliga raden bor i EN nyckel och kan granskas som en mening.
       Utan platsmarkören hamnade länken sist och läste som ett löst ord:
       «Du velger selv hva du godtar. personvernerklæringen». */
    if (TEKST) {
      var lenke = stykke.querySelector('a');
      if (lenke) lenke.textContent = 'integritetspolicy'; /* Shopifys ruta skriver «Privacy Policy» på engelska */
      var delar = TEKST.split('%link%');
      stykke.textContent = '';
      stykke.appendChild(document.createTextNode(delar[0]));
      if (lenke) {
        stykke.appendChild(lenke);
        stykke.appendChild(document.createTextNode(delar.length > 1 ? delar[1] : ''));
      } else if (delar.length > 1) {
        /* Ingen länk i Shopifys ruta: sy ihop meningen utan den, och lämna
           inget dinglande «Les mer i .» efter sig. */
        stykke.textContent = delar[0].replace(/\s*(Läs mer i vår|Les mer i|Read more in our)\s*$/, '');
      }
    }

    var tittel = banner.querySelector('#shopify-pc__banner__body-title');
    if (tittel && TITTEL) tittel.textContent = TITTEL;

    /* Alla tre knapparna skrivs om. Shopifys norska blandar former: «Avslå»
       och «Administrer preferanser» i imperativ, men «Akseptere» i infinitiv
       — den läser som en ordbokspost bredvid de andra. Norska knappar står i
       imperativ, och «Godta» rimmar dessutom med brödtextens «hva du godtar».
       «Preferanser» är dessutom anglicism där «innstillinger» är det norska. */
    var avsla = banner.querySelector('#shopify-pc__banner__btn-decline');
    if (avsla && AVSLA) avsla.textContent = AVSLA;

    var godta = banner.querySelector('#shopify-pc__banner__btn-accept');
    if (godta && GODTA) godta.textContent = GODTA;

    var innstillinger = banner.querySelector('#shopify-pc__banner__btn-manage-prefs');
    if (innstillinger && INNSTILLINGER) innstillinger.textContent = INNSTILLINGER;

    stykke.dataset.skOmskrevet = '1';
    return true;
  }

  function let_() {
    var banner = document.getElementById('shopify-pc__banner');
    return banner ? skrivOm(banner) : false;
  }

  if (let_()) return;

  /* Bannern kan dyka upp långt efter DOMContentLoaded. Vi tittar tills den
     kommer, och slutar titta när den gjort det eller efter 60 sekunder —
     annars ligger en observatör kvar och lyssnar på varje DOM-ändring resten
     av besöket. Cazeléa har 15 s; det räcker i praktiken men inte alltid på
     en trög uppkoppling, och en ruta som hinner fram efter tidsgränsen står
     kvar med Shopifys egen text. */
  var observator = new MutationObserver(function () {
    if (let_()) stopp();
  });

  function stopp() {
    observator.disconnect();
    clearTimeout(tidsgrense);
  }

  observator.observe(document.body, { childList: true, subtree: true });
  var tidsgrense = setTimeout(stopp, 60000);
})();

/*
  Mobilen (Daris 11 okt): rutan står mitt på skärmen över en mörk slöja, så
  att besökaren väljer innan sidan går att läsa. Godkänn och «Endast
  nödvändiga» är lika stora; slöjan tvingar fram ett val, inte ett ja.
  Slöjan följer rutan: den finns bara medan Shopifys ruta syns, och tas bort
  när ett val gjorts (visitorConsentCollected) eller rutan döljs.
*/
(function () {
  var mobil = window.matchMedia('(max-width: 749px)');
  var sloja = null, banner = null, klar = false;

  function syns(b) {
    return !!b && b.isConnected && getComputedStyle(b).display !== 'none' && b.getClientRects().length > 0;
  }

  function synka() {
    var visa = !klar && mobil.matches && syns(banner);
    if (visa && !sloja) {
      sloja = document.createElement('div');
      sloja.id = 'somne-kaksloja';
      sloja.setAttribute('aria-hidden', 'true');
      document.body.appendChild(sloja);
      document.documentElement.classList.add('somne-kak-oppen');
      banner.setAttribute('aria-modal', 'true');
    } else if (!visa && sloja) {
      sloja.remove();
      sloja = null;
      document.documentElement.classList.remove('somne-kak-oppen');
      if (banner) banner.setAttribute('aria-modal', 'false');
    }
  }

  function hitta() {
    var b = document.getElementById('shopify-pc__banner');
    if (!b) return false;
    banner = b;
    new MutationObserver(synka).observe(b, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
    synka();
    return true;
  }

  document.addEventListener('visitorConsentCollected', function () {
    klar = true;
    synka();
  });
  if (mobil.addEventListener) mobil.addEventListener('change', synka);

  if (hitta()) return;
  var leta = new MutationObserver(function () {
    if (hitta()) { leta.disconnect(); clearTimeout(slut); }
  });
  leta.observe(document.body, { childList: true, subtree: true });
  var slut = setTimeout(function () { leta.disconnect(); }, 60000);
})();
